import * as swcHelpers from '@swc/helpers';
import { format } from 'date-fns';
import { takeLatest, put } from 'redux-saga/effects';
import { DataLayer } from '@grandvisionhq/analytics';
import { clearEvents } from '../utils.js';
import { APPOINTMENTS_VIEW, UPCOMING_APPOINTMENT_VIEW, RESCHEDULE_APPOINTMENT } from './actions.js';

const mapAppointmentsForDataLayer = (a)=>{
    var ref, ref1;
    return {
        appointmentId: a.id,
        appointmentType: ((ref = a.appointmentType) === null || ref === void 0 ? void 0 : ref.name) || '',
        appointmentDate: format(a.startTime, 'ddMMyyyy'),
        appointmentTime: format(a.startTime, 'HH:mm'),
        storeName: ((ref1 = a.store) === null || ref1 === void 0 ? void 0 : ref1.name) || ''
    };
};
function* onAppointmentsView(action) {
    const evt = {
        event: 'myAccount',
        events: {
            category: 'my appointments',
            action: {
                block: 'appointment',
                interaction: 'view',
                appointments: action.payload.appointments.map(mapAppointmentsForDataLayer)
            }
        }
    };
    yield put(clearEvents());
    yield put(DataLayer.Actions.pushEvent(evt));
}
function* onGenericAppointmentAction(actionType, action) {
    const evt = {
        event: 'myAccount',
        events: {
            category: 'my appointments',
            action: swcHelpers.objectSpread({
                block: 'appointment',
                interaction: actionType
            }, mapAppointmentsForDataLayer(action.payload.appointment))
        }
    };
    yield put(clearEvents());
    yield put(DataLayer.Actions.pushEvent(evt));
}
/**
 * Main export
 */ var AppointmentsSagas = [
    takeLatest(APPOINTMENTS_VIEW, onAppointmentsView),
    takeLatest(UPCOMING_APPOINTMENT_VIEW, onGenericAppointmentAction, 'view'),
    takeLatest(RESCHEDULE_APPOINTMENT, onGenericAppointmentAction, 'reschedule'), 
];

export { AppointmentsSagas as default, onAppointmentsView, onGenericAppointmentAction };
//# sourceMappingURL=sagas.js.map
